import { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useStaticOptions } from "../context/StaticOptionsContext";
import TablerLayout from "../components/layout/TablerLayout";
import { useOrderSave } from "../context/OrderSaveContext";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast } from "../components/toasts/ToastService";

const VenyesTipus = () => {
	const { order, updateOrder} = useOrder();
	const { staticOptions, loading, error } = useStaticOptions();
	const [selectedOption, setSelectedOption] = useState(null);
	const navigate = useStepNavigate();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();

	if (loading)
		return (
			<TablerLayout title="Válassza ki a vény típusát!">
				<div className="text-center">Betöltés...</div>
			</TablerLayout>
		);
	if (error)
		return (
			<TablerLayout title="Válassza ki a vény típusát!">
				<div className="text-danger text-center">Hiba történt az opciók betöltésekor.</div>
			</TablerLayout>
		);

	const specAidTypes = staticOptions?.spec_aid_types || [];
	const hasSelection = Boolean(selectedOption || order?.hmeliorder?.hmeliorder_specaidtype);
	const activeSpecAidType = selectedOption?.cselispecaidtype_szam || order?.hmeliorder?.hmeliorder_specaidtype;

	const handleOptionClick = (option) => {
		setSelectedOption(option);
	};

	const handleContinue = async () => {
		const optionToPersist =
			selectedOption ||
			specAidTypes.find((type) => type.cselispecaidtype_szam === order?.hmeliorder?.hmeliorder_specaidtype) ||
			(order?.hmeliorder?.hmeliorder_specaidtype
				? {
					cselispecaidtype_szam: order.hmeliorder.hmeliorder_specaidtype,
					cselispecaidtype_national: order.hmeliorder.hmeliorder_specaidtype_national,
				}
				: null);

		if (!optionToPersist) {
			showErrorToast("Kérjük, válasszon vény típust!");
			return;
		}

		try {
			const updatedOrder = {
				...order,
				hmeliorder: {
					...order.hmeliorder,
					hmeliorder_specaidtype: optionToPersist.cselispecaidtype_szam,
					hmeliorder_specaidtype_national: optionToPersist.cselispecaidtype_national,
				},
				aktivVenyIndex: 0,
			};

			updateOrder(updatedOrder);
			const result = await saveOrder(updatedOrder);

			if (result?.success !== false) {
				navigate("/VenyekLista");
			} else {
				showErrorToast(result?.message || "Hiba történt a rendelés mentése során!");
			}
		} catch (error) {
			console.error("Hiba történt a vény típusának mentésekor:", error);
		}
	};

	return (
		<TablerLayout title="Válassza ki a vény típusát!">
			<div className="row justify-content-center">
				<div className="col-md-10 text-center mb-4">
					<div className="row g-4 justify-content-center">
						{specAidTypes.map((type, idx) => (
							<div key={type.cselispecaidtype_szam} className="col-12 col-md-6 d-flex justify-content-center">
								<button type="button" className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold ${activeSpecAidType === type.cselispecaidtype_szam ? "btn-primary" : "btn-outline-primary"}`} style={{ fontSize: 22 }} onClick={() => handleOptionClick(type)}>
									{type.cselispecaidtype_national}
								</button>
							</div>
						))}
					</div>
				</div>
			</div>
			<StepperNavButton side="right" label="Tovább" onClick={handleContinue} disabled={!hasSelection || orderSaveLoading} />
		</TablerLayout>
	);
};

export default VenyesTipus;
